import { useEffect, useState } from "react";
import { FetchCaseAppealListParams } from "../../../data-model/caseAppealsTable";
import { FilterValues } from "../../../data-model/filterValues";
import { buildAppealListPayload } from "../utils/buildAppealListPayload";

/** POST body shape for backend `pharmacy/appeal/list`. */
export type AppealListFilterPayload = FetchCaseAppealListParams;

export interface UseFilterPayloadReturn {
  filterPayload: AppealListFilterPayload | null;
  setFilterPayload: React.Dispatch<
    React.SetStateAction<AppealListFilterPayload | null>
  >;
}

/**
 * Builds the appeal list payload when filters or the search term change after initial load.
 *
 * @param validFilters - Applied table filters from Redux
 * @param searchTerm - Current search text (empty when not searching)
 * @param initialDataFetchingExecuted - Whether the first page has loaded
 * @param pageSize - Page size sent as `limit` to the appeal list API
 * @returns Current filter payload and setter
 */
export const useFilterPayload = (
  validFilters: FilterValues[],
  searchTerm: string,
  initialDataFetchingExecuted: boolean,
  pageSize: number = 50,
): UseFilterPayloadReturn => {
  const [filterPayload, setFilterPayload] =
    useState<AppealListFilterPayload | null>(null);

  useEffect(() => {
    if (!initialDataFetchingExecuted) {
      setFilterPayload(null);
      return;
    }

    setFilterPayload(
      buildAppealListPayload(validFilters, searchTerm, pageSize),
    );
  }, [validFilters, searchTerm, initialDataFetchingExecuted, pageSize]);

  return {
    filterPayload,
    setFilterPayload,
  };
};
